import {ApiRoutes} from '../../configs/api.config';
import {requestService} from '@bobex/react-core/services/RequestService';
import {CpvView} from './view/CpvView';

export const CpvModelAPI = {
  /**
   * Fetches the CPV (2008) list for the sidebar.
   * @param lang - Optional language code (e.g. 'fr', 'nl', 'en')
   * @returns Promise resolving to an array of CpvView
   */
  getList: async (lang?: string): Promise<CpvView[]> => {
    const response = await requestService.get(ApiRoutes.REST_API_CPV_LIST, { lang });
    const data = response.data;
    return Array.isArray(data) ? data : [];
  },
};
